import {
    android_method_checker,
    ios_method_checker,
    genUuid,
    throwErr,
    checkIsFn,
    oldIOS_method_checker,
    handleAndroidParamArr,
    isAndroid,
} from "./utils";
import {
    IUserInfo, ISystemInfo, ICityInfo, IShareParam,
    INavigationParams, INavigationTitleParams, IBaseHandler, INavButtonParams,
    IToastParams, IStorageParams, IStorageRemoveParams, IActionParams, ISubscribeParams,
    ZhiMa, INativeShareParam, IAlipayParams,
} from './interface';
import oldBridgeHandler from './oldBridgeHandler';

/* eslint-disable */

const androidMethodAccessible = (methodName: string) => {
    return window && window.tantan && typeof window.tantan.canIUse === 'function' && window.tantan.canIUse(methodName);
};

/**
 * 获取用户信息
 */
export const getUserInfo = () => {
    const fnName = 'getUserInfo';
    if (androidMethodAccessible(fnName)) {
        const res = JSON.parse(window.tantan.dispatch(fnName, JSON.stringify([])));
        if (typeof res === 'object') {
            return Object.keys(res).length === 0 ? Promise.reject('unknown user') : Promise.resolve(res as IUserInfo)
        }
        return console.error('internal error')
    }
    if (ios_method_checker(fnName)) {
        const uid = genUuid();
        return new Promise<IUserInfo>((resolve, reject) => {
            window[`${fnName}Success${uid}`] = (res: string) => {
                resolve(JSON.parse(res) as IUserInfo);
            };
            window[`${fnName}Fail${uid}`] = () => { reject('unknown user') };
            window.webkit.messageHandlers.getUserInfo.postMessage({
                success: `${fnName}Success${uid}`,
                fail: `${fnName}Fail${uid}`,
            });
        })
    }
    // 若为旧版sdk，则调用saveBean方法
    if (android_method_checker('saveBean') || ios_method_checker('saveBean') || oldIOS_method_checker('saveBean')) {
        return oldBridgeHandler('saveBean');
    }
    console.error('no method matched for getUserInfo');
    return {
        userId: "10086",
        userName: ''
    } as IUserInfo;
};



/** AB分组的header头 */
export const getAbHeader = () => {
    const fnName = 'getAbHeader';
    if (isAndroid) {
        if (androidMethodAccessible(fnName)) {
            const res = window.tantan.dispatch(fnName, JSON.stringify([]));
            return Promise.resolve(res as string);
        } else if (android_method_checker(fnName)) {
            return Promise.resolve(window.tantan[fnName]() as string);
        }
    }
    if (oldIOS_method_checker(fnName)) {
        return window[fnName]() as string;
    }
    if (ios_method_checker(fnName)) {
        console.log('enter into method getAbHeader')
        return new Promise<string>((resolve, reject) => {
            const uid = genUuid();
            window[`${fnName}Success${uid}`] = (res: string) => {
                resolve(res);
            };
            window[`${fnName}Fail${uid}`] = (err: any) => {
                reject(err);
            };
            window.webkit.messageHandlers[fnName].postMessage({
                success: `${fnName}Success${uid}`,
                fail: `${fnName}Fail${uid}`,
            });
        })
    }
    console.error('no method matched for getAbHeader')
}


/**
 * 获取系统信息
 */
export const getSystemInfo:(() => Promise<ISystemInfo>) = () => {
    const fnName = 'getSystemInfo';
    if (androidMethodAccessible(fnName)) {
        const res = JSON.parse(window.tantan.dispatch(fnName, JSON.stringify([])));
        if (res.appVersion) {
            res.versionCode = res.appVersion;
        }
        if (res.sdkVersion) {
            res.schemeVersion = res.sdkVersion
        }
        if (res.os) {
            res.platform = res.os
        }
        return Promise.resolve(typeof res === 'object' ? res as ISystemInfo : {} as ISystemInfo);
    }
    if (ios_method_checker(fnName)) {
        return new Promise((resolve, reject) => {
            const uid = genUuid();
            window[`${fnName}Success${uid}`] = (res: string) => {
                const result = JSON.parse(res);
                if (result.appVersion) {
                    result.versionCode = result.appVersion;
                }
                if (result.sdkVersion) {
                    result.schemeVersion = result.sdkVersion
                }
                if (result.os) {
                    result.platform = result.os;
                }
                resolve(result as ISystemInfo)
            };
            window[`${fnName}Fail${uid}`] = (err: any) => { reject(err) }
            window.webkit.messageHandlers[fnName].postMessage({
                success: `${fnName}Success${uid}`,
                fail: `${fnName}Fail${uid}`,
            })
        })
    }
    // 若为旧版sdk，则调用saveBean方法
    if (android_method_checker('saveBean') || ios_method_checker('saveBean') || oldIOS_method_checker('saveBean')) {
        return oldBridgeHandler('saveBean')
    }
    console.error('no method matched for getSystemInfo')
    return Promise.resolve({} as ISystemInfo)
};

/**
 * 获取网络信息
 */
export const getNetworkInfo = () => {
    const fnName = 'getNetworkInfo';
    if (androidMethodAccessible(fnName)) {
        return Promise.resolve(window.tantan.dispatch(fnName, JSON.stringify([])));
    }
    if (ios_method_checker(fnName)) {
        return new Promise<string>((resolve, reject) => {
            const uid = genUuid();
            window[`${fnName}Success${uid}`] = (res: string) => {
                const parsed = JSON.parse(res);
                parsed.networkType && resolve(parsed.networkType)
            };
            window[`${fnName}Fail${uid}`] = (err: any) => { reject(err) }
            window.webkit.messageHandlers[fnName].postMessage({
                success: `${fnName}Success${uid}`,
                fail: `${fnName}Fail${uid}`,
            })
        })
    }
    console.error('no method matched for getNetworkInfo');
};

/**
 * 新开webview
 * @param urlOrSchema url地址或schema地址
 * @param title webview标题
 */
export const openWebview = (urlOrSchema: string, title: string = '') => {
    if (!urlOrSchema) {
        throwErr('param url is REQUIRED!')
    }
    const fnName = 'openWebview';
    if (androidMethodAccessible(fnName)) {
        return window.tantan.dispatch(fnName, JSON.stringify(handleAndroidParamArr([urlOrSchema, title])));
    }
    if (ios_method_checker(fnName) && ios_method_checker('jumpWebview')) { // 新老版本都存在openwebview的情况，故增加用是否存在jumpWebview来区分是否为新版,若后续需要更精细化的区分，则调用获取系统信息来判断版本号
        const paramBody = /http/g.test(urlOrSchema) ? { url: urlOrSchema, title } : { schema: urlOrSchema, title };
        return new Promise((resolve, reject) => {
            const uid = genUuid();
            window[`${fnName}Success${uid}`] = (res: string) => {
                resolve(JSON.parse(res))
            };
            window[`${fnName}Fail${uid}`] = (err: any) => { reject(err) }
            window.webkit.messageHandlers[fnName].postMessage(paramBody)
        })
    }
    // 兼容老版本没有openWebview，针对指定的schema调用老版的bridge方法
    // const migrateSchemas = [
    //     'tantanapp://profile/edit',
    //     'tantanapp://vip/vip/buy',
    //     'tantanapp://vip/boost/buy',
    //     'tantan://liveCover',
    // ]
    if ((android_method_checker('action') || ios_method_checker('action') || oldIOS_method_checker('action'))) {
        oldBridgeHandler('action', { schema: urlOrSchema })
    }
    console.error('no method matched for openWebview');
};

/**
 * 新开webview同时关闭当前webview
 * @param urlOrSchema url地址或schema地址
 * @param title webview标题
 */
export const jumpWebview = (urlOrSchema: string, title: string = '') => {
    if (!urlOrSchema) {
        throwErr('param url is REQUIRED!')
    }
    const fnName = 'jumpWebview';
    if (androidMethodAccessible(fnName)) {
        return window.tantan.dispatch(fnName, JSON.stringify(handleAndroidParamArr([urlOrSchema, title])));
    }
    if (ios_method_checker(fnName)) {
        const paramBody = /http/g.test(urlOrSchema) ? { url: urlOrSchema, title } : { schema: urlOrSchema, title };
        return new Promise((resolve, reject) => {
            const uid = genUuid();
            window[`${fnName}Success${uid}`] = (res: string) => {
                resolve(JSON.parse(res))
            };
            window[`${fnName}Fail${uid}`] = (err: any) => { reject(err) }
            window.webkit.messageHandlers[fnName].postMessage(paramBody)
        })
    }
    console.error('no method matched for jumpWebview');
};


/**
 * 关闭当前webview
 */
export const closeWebview = () => {
    const fnName = 'closeWebview';
    if (androidMethodAccessible(fnName)) {
        return window.tantan.dispatch(fnName, JSON.stringify([]));
    }
    if (ios_method_checker(fnName)) {
        window.webkit.messageHandlers[fnName].postMessage({})
    }
    if (android_method_checker(fnName) || oldIOS_method_checker(fnName)) {
        return oldBridgeHandler(fnName);
    }
    console.error(`no method matched for ${fnName}`);
};


/**
 * 关闭当前webview(弹窗类)
 */
export const closeDialogWebview = () => {
    const fnName = 'closeDialogWebview';
    if (androidMethodAccessible(fnName)) {
        return window.tantan.dispatch(fnName, JSON.stringify([]));
    }
    if (ios_method_checker(fnName)) {
        return window.webkit.messageHandlers[fnName].postMessage({})
    }
    if (android_method_checker('closeLiveCampaignDialog') || ios_method_checker('closeLiveCampaignDialog')) {
        return oldBridgeHandler('closeLiveCampaignDialog')
    }
    console.error(`no method matched for ${fnName}`);

};


/**
 * 获取城市信息
 */
export const getCityInfo = () => {
    const fnName = 'getCityInfo'
    if (androidMethodAccessible(fnName)) {
        const res = JSON.parse(window.tantan.dispatch(fnName, JSON.stringify([])));
        return Promise.resolve(typeof res === 'object' ? res as ICityInfo : {});
    }
    if (ios_method_checker(fnName)) {
        return new Promise((resolve, reject) => {
            const uid = genUuid();
            window[`${fnName}Success${uid}`] = (res: string) => {
                resolve(JSON.parse(res))
            };
            window[`${fnName}Fail${uid}`] = (err: any) => { reject(err) }
            window.webkit.messageHandlers[fnName].postMessage({
                success: `${fnName}Success${uid}`,
                fail: `${fnName}Fail${uid}`
            });
        })
    }
    console.error(`no method matched for ${fnName}`);
};


/**
 * 分享（需要指定分享渠道）
 * @param params
 */
export const share = (params: IShareParam) => {
    const { url, title = '', description = '', imgUrl, channel, successHandler = Function.prototype, errorHandler = Function.prototype } = params;
    if (successHandler && typeof successHandler !== "function" || errorHandler && typeof errorHandler !== "function") {
        throw 'handler must be a function!'
    }
    if (!url || !channel) {
        throw 'param is invalid'
    }
    const fnName = 'share';
    if (isAndroid) {
        const uid = genUuid();
        window[`success${uid}`] = successHandler;
        window[`error${uid}`] = errorHandler;
        if (androidMethodAccessible(fnName)) {
            const paramArr = JSON.stringify(handleAndroidParamArr([url, title, description, imgUrl, channel, `success${uid}`, `error${uid}`]))
            window.tantan.dispatch(fnName, paramArr)
        } else if (android_method_checker(fnName)) {
            return window.tantan.share(url, title, description, imgUrl, channel, `success${uid}`)
        }
    }
    if (ios_method_checker(fnName)) {
        const uid = genUuid();
        window[`success${uid}`] = successHandler;
        window[`error${uid}`] = errorHandler;
        window.webkit.messageHandlers[fnName].postMessage({
            url,
            title,
            description,
            imgUrl,
            channel,
            success: `success${uid}`,
            fail: `error${uid}`
        });
    }
    console.error(`no method matched for ${fnName}`);
};


/**
 * 弹窗分享
 */
export const nativeShare = (params: INativeShareParam) => {
    const { url, title = '', description = '', imgUrl, successHandler = Function.prototype, errorHandler = Function.prototype, modalTitle = '', channels = '' } = params;
    if (successHandler && typeof successHandler !== "function" || errorHandler && typeof errorHandler !== "function") {
        throw 'handler must be a function!'
    }
    if (!url) {
        throw 'param is invalid'
    }
    const fnName = 'nativeShare';
    if (androidMethodAccessible(fnName)) {
        const uid = genUuid();
        window[`success${uid}`] = successHandler;
        window[`error${uid}`] = errorHandler;
        const paramArr = JSON.stringify(handleAndroidParamArr([url, title, description, imgUrl, `success${uid}`, `error${uid}`, modalTitle, channels]))
        window.tantan.dispatch(fnName, paramArr)
    }
    if (ios_method_checker(fnName)) {
        const uid = genUuid();
        window[`success${uid}`] = successHandler;
        window[`error${uid}`] = errorHandler;
        window.webkit.messageHandlers[fnName].postMessage({
            url,
            title,
            description,
            imgUrl,
            success: `success${uid}`,
            fail: `error${uid}`,
            modalTitle,
            channels,
        });
    }
    console.error(`no method matched for ${fnName}`);
};


/**
 * 设置导航栏
 */
export const setNavigation = (params: INavigationParams) => {
    const { title = '', handler = Function.prototype, leftImgUrl = '', leftText = '', leftHandler = Function.prototype, rightImgUrl = '', rightText = '', rightHandler = Function.prototype, successHandler = Function.prototype, errorHandler = Function.prototype } = params;
    if (!checkIsFn([handler, successHandler, errorHandler, leftHandler, rightHandler])) {
        return throwErr('handler must be function')
    }
    if (!title) {
        return throwErr('param title is REQUIRED')
    }
    const fnName = 'setNavigation';
    const uid = genUuid();
    window[`success${uid}`] = successHandler;
    window[`error${uid}`] = errorHandler;
    window[`leftHandler${uid}`] = leftHandler;
    window[`rightHandler${uid}`] = rightHandler;
    window[`handler${uid}`] = handler;
    if (androidMethodAccessible(fnName)) {
        const paramArr = JSON.stringify(handleAndroidParamArr([title, `handler${uid}`, leftImgUrl, leftText && leftImgUrl ? '' : leftText, `leftHandler${uid}`, rightImgUrl, rightText && rightImgUrl ? '' : rightText, `rightHandler${uid}`, `success${uid}`, `error${uid}`]));
        window.tantan.dispatch(fnName, paramArr)
    }
    if (ios_method_checker(fnName)) {
        window.webkit.messageHandlers[fnName].postMessage({
            title,
            handler: `handler${uid}`,
            leftImgUrl,
            leftText: leftText && leftImgUrl ? '' : leftText,
            leftHandler: `leftHandler${uid}`,
            rightImgUrl,
            rightText: rightText && rightImgUrl ? '' : rightText,
            rightHandler: `rightHandler${uid}`,
            success: `success${uid}`,
            fail: `error${uid}`
        });
    }
    console.error(`no method matched for ${fnName}`);
};

/**
 * 设置导航栏标题
 * @param params
 */
export const setNavigationTitle = (params: INavigationTitleParams) => {
    const { title = '', handler = Function.prototype, successHandler = Function.prototype, errorHandler = Function.prototype } = params;
    if (!checkIsFn([handler, successHandler, errorHandler])) {
        return throwErr('handler must be function')
    }
    if (!title) {
        return throwErr('param title is REQUIRED')
    }
    const fnName = 'setNavigationTitle';
    const uid = genUuid();
    window[`success${uid}`] = successHandler;
    window[`error${uid}`] = errorHandler;
    window[`handler${uid}`] = handler;
    if (androidMethodAccessible(fnName)) {
        const paramArr = JSON.stringify(handleAndroidParamArr([title, `handler${uid}`, `success${uid}`, `error${uid}`]));
        window.tantan.dispatch(fnName, paramArr)
    }
    if (ios_method_checker(fnName)) {
        window.webkit.messageHandlers[fnName].postMessage({
            title,
            handler: `handler${uid}`,
            success: `success${uid}`,
            fail: `error${uid}`
        });
    }
    if (android_method_checker('setTitle') || oldIOS_method_checker('setTitle')) {
        oldBridgeHandler('setTitle', title)
    }
    console.error(`no method matched for ${fnName}`);
};

/**
 * 隐藏导航栏
 * @param params
 */
export const hideNavigation = (params: IBaseHandler) => {
    const { successHandler = Function.prototype, errorHandler = Function.prototype } = params;
    if (!checkIsFn([successHandler, errorHandler])) {
        return throwErr('handler must be function')
    }
    const fnName = 'hideNavigation';
    const uid = genUuid();
    window[`success${uid}`] = successHandler;
    window[`error${uid}`] = errorHandler;
    if (androidMethodAccessible(fnName)) {
        const paramArr = JSON.stringify(handleAndroidParamArr([`success${uid}`, `error${uid}`]));
        window.tantan.dispatch(fnName, paramArr)
    }
    if (ios_method_checker(fnName)) {
        window.webkit.messageHandlers[fnName].postMessage({
            success: `success${uid}`,
            fail: `error${uid}`
        });
    }
    console.error(`no method matched for ${fnName}`);
};

/**
 * 设置导航栏左侧按钮
 * @param params
 */
export const setNavLeftButton = (params: INavButtonParams) => {
    const { text = '', imgUrl = '', handler = Function.prototype, successHandler = Function.prototype, errorHandler = Function.prototype } = params;
    if (!checkIsFn([handler, successHandler, errorHandler])) {
        return throwErr('handler must be function')
    }
    if (!text && !imgUrl) {
        throwErr('param missing')
    }
    const fnName = 'setNavLeftButton';
    const uid = genUuid();
    window[`success${uid}`] = successHandler;
    window[`error${uid}`] = errorHandler;
    window[`handler${uid}`] = handler;
    if (androidMethodAccessible(fnName)) {
        const paramArr = JSON.stringify(handleAndroidParamArr([!text && imgUrl ? imgUrl : '', text, `handler${uid}`, `success${uid}`, `error${uid}`]))
        window.tantan.dispatch(fnName, paramArr)
    }
    if (ios_method_checker(fnName)) {
        window.webkit.messageHandlers[fnName].postMessage({
            text,
            imgUrl,
            handler: `handler${uid}`,
            success: `success${uid}`,
            fail: `error${uid}`
        });
    }
    console.error(`no method matched for ${fnName}`);
};

/**
 * 设置导航栏右侧按钮
 * @param params
 */
export const setNavRightButton = (params: INavButtonParams) => {
    const { text = '', imgUrl = '', handler = Function.prototype, successHandler = Function.prototype, errorHandler = Function.prototype } = params;
    if (!checkIsFn([handler, successHandler, errorHandler])) {
        return throwErr('handler must be function')
    }
    if (!text && !imgUrl) {
        throwErr('param missing')
    }
    const fnName = 'setNavRightButton';
    const uid = genUuid();
    window[`success${uid}`] = successHandler;
    window[`error${uid}`] = errorHandler;
    window[`handler${uid}`] = handler;
    if (androidMethodAccessible(fnName)) {
        const paramArr = JSON.stringify(handleAndroidParamArr([!text && imgUrl ? imgUrl : '', text, `handler${uid}`, `success${uid}`, `error${uid}`]));
        window.tantan.dispatch(fnName, paramArr)
    }
    if (ios_method_checker(fnName)) {
        window.webkit.messageHandlers[fnName].postMessage({
            text,
            imgUrl,
            handler: `handler${uid}`,
            success: `success${uid}`,
            fail: `error${uid}`
        });
    }
    console.error(`no method matched for ${fnName}`);
};


/**
 * 系统原生toast提醒
 * @param params
 */
export const showToast = (params: IToastParams) => {
    const { context, duration = 3000 } = params;
    if (!context) {
        return throwErr('param context is REQUIRED');
    }
    const fnName = 'showToast';
    if (androidMethodAccessible(fnName)) {
        const paramArr = JSON.stringify(handleAndroidParamArr([context, duration]));
        window.tantan.dispatch('showToast', paramArr)
    }
    if (ios_method_checker(fnName)) {
        window.webkit.messageHandlers[fnName].postMessage({
            context,
            duration
        });
    }
    console.error(`no method matched for ${fnName}`);
};

/**
 * 设置指定键值的本地存储
 * @param params
 */
export const setStorage = (params: IStorageParams) => {
    const { key, data, successHandler = Function.prototype, errorHandler = Function.prototype } = params;
    if (!checkIsFn([successHandler, errorHandler])) {
        return throwErr('handler must be function')
    }
    const fnName = 'setStorage';
    if (!key || !data) {
        return throwErr('param key & data is REQUIRED');
    }
    const uid = genUuid();
    window[`success${uid}`] = successHandler;
    window[`error${uid}`] = errorHandler;
    if (androidMethodAccessible(fnName)) {
        const paramArr = JSON.stringify(handleAndroidParamArr([key, data, `success${uid}`, `error${uid}`]));
        window.tantan.dispatch(fnName, paramArr);
    }
    if (ios_method_checker(fnName)) {
        window.webkit.messageHandlers[fnName].postMessage({
            key,
            data,
            success: `success${uid}`,
            fail: `error${uid}`
        });
    }
    console.error(`no method matched for ${fnName}`);
};

/**
 * 获取指定键值的本地存储
 * @param key
 */
export const getStorage = (key: string) => {
    const handleJsonString = (string: string)=> {
        if (!string) {
            return '';
        }
        if (/^{.*}$/.test(string)) {
            return JSON.parse(string);
        }
        return string;
    }
    if (!key) {
        return throwErr('param key is REQUIRED');
    }
    const fnName = 'getStorage';
    if (androidMethodAccessible(fnName)) {
        const paramArr = JSON.stringify(handleAndroidParamArr([key]));
        const res = window.tantan.dispatch('getStorage', paramArr);
        if (res === 'KEY_NOT_EXIST') {
            return Promise.reject('1');
        } else {
            return Promise.resolve(handleJsonString(res))
        }
    }
    if (ios_method_checker(fnName)) {
        return new Promise((resolve, reject) => {
            const uid = genUuid();
            window[`${fnName}Success${uid}`] = (res: string) => {
                resolve(handleJsonString(res))
            };
            window[`${fnName}Fail${uid}`] = (err: any) => { reject(err) }
            window.webkit.messageHandlers[fnName].postMessage({
                key,
                success: `${fnName}Success${uid}`,
                fail: `${fnName}Fail${uid}`
            })
        })
    }
    console.error(`no method matched for ${fnName}`);
};

/**
 * 移除指定键值的本地存储
 * @param params
 */
export const removeStorage = (params: IStorageRemoveParams) => {
    const { key, successHandler = Function.prototype, errorHandler = Function.prototype } = params;
    if (!key) {
        return throwErr('param key is REQUIRED');
    }
    if (!checkIsFn([successHandler, errorHandler])) {
        return throwErr('handler must be function')
    }
    const fnName = 'removeStorage';
    const uid = genUuid();
    window[`success${uid}`] = successHandler;
    window[`error${uid}`] = errorHandler;
    if (androidMethodAccessible(fnName)) {
        const paramArr = JSON.stringify(handleAndroidParamArr([key, `success${uid}`, `error${uid}`]));
        window.tantan.dispatch(fnName, paramArr);
    }
    if (ios_method_checker(fnName)) {
        window.webkit.messageHandlers[fnName].postMessage({
            key,
            success: `success${uid}`,
            fail: `error${uid}`
        });
    }
    console.error(`no method matched for ${fnName}`);
};

/**
 * 清空本地存储
 * @param params
 */
export const clearStorage = (params: IBaseHandler) => {
    const { successHandler = Function.prototype, errorHandler = Function.prototype } = params;
    if (!checkIsFn([successHandler, errorHandler])) {
        return throwErr('handler must be function')
    }
    const fnName = 'clearStorage';
    const uid = genUuid();
    window[`success${uid}`] = successHandler;
    window[`error${uid}`] = errorHandler;
    if (androidMethodAccessible(fnName)) {
        const paramArr = JSON.stringify(handleAndroidParamArr([`success${uid}`, `error${uid}`]));
        window.tantan.dispatch(fnName, paramArr);
    }
    if (ios_method_checker(fnName)) {
        window.webkit.messageHandlers[fnName].postMessage({
            success: `success${uid}`,
            fail: `error${uid}`
        });
    }
    console.error(`no method matched for ${fnName}`);
};

/**
 * 客户端基于约定的消息完成对应的操作(比如刷新用户信息等)
 * @param params
 */
export const triggerAction = (params: IActionParams) => {
    const { actionType, restParams = {} } = params;
    if (!actionType) {
        return throwErr('param actionType is REQUIRED');
    }
    console.log(actionType)
    const fnName = 'triggerAction';
    const uid = genUuid();
    const handleRestParams = (params: any)=> {
        const resParams: any = {};
        Object.keys(params).forEach(key => {
            if (typeof params[key] === 'function') {
                window[`${actionType}_${key}_${uid}`] = params[key];
                return resParams[key] = `${actionType}_${key}_${uid}`;
            }
            resParams[key] = params[key]
        });
        return resParams;
    };
    if (actionType === 'track' && restParams.params && Object.prototype.toString.call(restParams.params) === '[object Object]') {
        let kvs: string[] = [];
        for (let key in restParams.params) {
            kvs = kvs.concat(String(key), String(restParams.params[key]));
        }
        restParams.params = kvs;
    }
    if (android_method_checker('triggerAction')) {
        const filterParams = handleRestParams(restParams);
        // todo track的特殊逻辑是否要下放至业务项目
        const restParamsArr = Object.keys(filterParams).map((x) => filterParams[x]);
        const paramArr = JSON.stringify(handleAndroidParamArr(restParamsArr));
        return window.tantan.triggerAction(actionType, paramArr)
    }
    if (ios_method_checker(fnName)) {
        if (actionType === 'subscribeCampaign') {
          window.flagUid = uid;
        }
        console.log(handleRestParams(restParams))
        return window.webkit.messageHandlers[fnName].postMessage({
            actionType,
            ...handleRestParams(restParams),
        });
    }
    const migrateMethods = [
        'refreshLiveAuth', 'jumpRecharge', 'refreshGuildAuth', 'jumpToCover', 'onTeenModeEnable',
        'verifyTeenModePassword', 'dialogJumpRecharge', 'closeLiveCampaignDialog', 'refreshUserCounters',
        'jumpToLiveAnchor', 'jumpToProfile', 'jumpToRoom', 'onRedPacketOpen', 'subscribeCampaign', 'showRechargeDialog',
        'liveGiftDialogController', 'campaignController', 'track', 'jumpToSeeOrBuySee', 'unRegisterBarRight', 'registerBarRight', 'follow', 'liveNewUserRedPacketController',
        'imagePicker', 'jumpToTopicAggregationAct', 'jumpToTopicVoteAggregationAct', 'jumpToTopic', 'jumpToProfileAct',
    ];
    if (~migrateMethods.indexOf(actionType) && (android_method_checker(actionType) || ios_method_checker(actionType) || oldIOS_method_checker(actionType))) {
        console.log('method triggerAction not exist, enter oldBridgeHandler')
        return oldBridgeHandler(actionType, restParams)
    }
    // IOS中track方法名为trackEvent
    if (actionType === 'track' && (ios_method_checker('trackEvent') || oldIOS_method_checker('trackEvent'))) {
        return oldBridgeHandler(actionType, restParams)
    }
    console.error(`no method matched for ${fnName}`);
};

/**
 * 订阅(h5订阅指定type的消息，当事件触发时客户端调用订阅该消息的webview传入的回调函数)
 * @param params
 */
export const subscribe = (params: ISubscribeParams) => {
    const { subscribeType, subscribeHandler = Function.prototype, successHandler = Function.prototype, errorHandler = Function.prototype } = params;
    if (!subscribeType) {
        return throwErr('param subscribeType is REQUIRED');
    }
    if (!checkIsFn([successHandler, errorHandler, subscribeHandler])) {
        return throwErr('handler must be function')
    }
    const fnName = 'subscribe';
    const uid = genUuid();
    window[`success${uid}`] = successHandler;
    window[`error${uid}`] = errorHandler;
    window[`subscribeHandler${uid}`] = subscribeHandler;
    if (androidMethodAccessible(fnName)) {
        const paramArr = JSON.stringify(handleAndroidParamArr([subscribeType, `subscribeHandler${uid}`, `success${uid}`, `error${uid}`]));
        window.tantan.dispatch(fnName, paramArr);
    }
    if (ios_method_checker(fnName)) {
        window.webkit.messageHandlers[fnName].postMessage({
            subscribeType,
            success: `success${uid}`,
            fail: `error${uid}`,
            subscribeHandler: `subscribeHandler${uid}`,
        });
    }
    console.error(`no method matched for ${fnName}`);
};

/**获取HMAC版的授权码
 * getAuthorizationHeader函数被重载, 在安卓下不可进行重命名
 */
export const getAuthorizationHeader = (url?: string, body?: any) => {
    const fnName = 'getAuthorizationHeader';
    if (isAndroid) {
        if (androidMethodAccessible(fnName)) {
            const paramArr = JSON.stringify(handleAndroidParamArr([url, body || '']));
            const res = window.tantan.dispatch(fnName, paramArr);
            return Promise.resolve(res)
        } else if (android_method_checker(fnName)) {
            if (body) {
                return Promise.resolve(window.tantan[fnName](url, JSON.stringify(body)));
            } else {
                return Promise.resolve(window.tantan[fnName](url))
            }
        }
    } else if (oldIOS_method_checker(fnName)) {
        if (body) {
            return window[fnName](url, JSON.stringify(body))
        } else {
            return window[fnName](url)
        }
    } else if (ios_method_checker(fnName)) {
        return new Promise((resolve, reject) => {
            const uid = genUuid();
            window[`${fnName}Success${uid}`] = (res: string) => { resolve(res) }
            window[`${fnName}Fail${uid}`] = (err: any) => { reject(err) }
            window.webkit.messageHandlers.getAuthorizationHeader.postMessage({
                url,
                body: body ? JSON.stringify(body) : undefined,
                success: `${fnName}Success${uid}`,
                fail: `${fnName}Fail${uid}`,
            })
        })
    }
    console.error(`no method matched for ${fnName}`);
}


/** 芝麻认证 */
export const bindZhimaAuth = ({
                                  name,
                                  id,
                                  successZhima,
                                  failZhima
                              }: ZhiMa) => {
    const fnName = 'bindZhimaAuth';
    if (isAndroid) {
        window.callbackZhimaSuccess = successZhima;
        window.callbackZhimaFail = failZhima;
        if (androidMethodAccessible(fnName)) {
            const paramArr = JSON.stringify(handleAndroidParamArr([name, id, 'callbackZhimaSuccess', 'callbackZhimaFail']));
            window.tantan.dispatch(fnName, paramArr)
        } else if (android_method_checker(fnName)) {
            window.tantan.bindZhimaAuth(
                name,
                id,
                'callbackZhimaSuccess',
                'callbackZhimaFail'
            );
        }
    } else if (oldIOS_method_checker("bindZhimaAuth")) {
        const callbackZhimaSuccess = () => {
            successZhima()
        }
        const callbackZhimaFail = (res: any) => {
            failZhima(res)
        }
        window.bindZhimaAuth(name, id, callbackZhimaSuccess, callbackZhimaFail);
    } else if (ios_method_checker('bindZhimaAuth')) {
        window.callbackZhimaSuccess = successZhima;
        window.callbackZhimaFail = failZhima;
        window.webkit.messageHandlers.bindZhimaAuth.postMessage({
            name,
            num: id,
            success: 'callbackZhimaSuccess',
            fail: 'callbackZhimaFail',
        })
    } else {
        console.info("无法绑定实名认证", 0.5);
    }
};


/** 新打点 */
export function trackNew(trackData: {
    type: string
    pageId: string
    eid?: string
    extras?: { [key: string]: string }
}) {
    const fnName = 'trackNew';
    if (isAndroid) {
        const { type, pageId, eid = '', extras } = trackData;
        let kvs: string[] = [];
        if (extras) {
            for (let key in extras) {
                kvs = kvs.concat(String(key), String(extras[key]));
            }
        }
        if (androidMethodAccessible(fnName)) {
            const paramsArr = handleAndroidParamArr([type, eid, pageId, kvs]);
            return window.tantan.dispatch(fnName, JSON.stringify(paramsArr));
        } else if (android_method_checker(fnName)) {
            return window.tantan.trackNew(type, eid, pageId, kvs);
        }
    } else if (oldIOS_method_checker("trackNew")) {
        window.trackNew(trackData);
    } else if (ios_method_checker('trackNew')) {
        return window.webkit.messageHandlers.trackNew.postMessage(trackData)
    } else {
        console.info("无法进行新打点", 0.5);
    }
}



/** 6. 绑定支付宝 */
export function bindAlipay({ successAlipay, failAlipay }: IAlipayParams) {
    const uid = genUuid();
    const fnName = 'bindAlipay';
    if (isAndroid) {
        window[`successAlipay${uid}`] = successAlipay;
        window[`failAlipay${uid}`] = failAlipay;
        if (androidMethodAccessible(fnName)) {
            return window.tantan.dispatch(fnName, JSON.stringify(handleAndroidParamArr([`successAlipay${uid}`, `failAlipay${uid}`])));
        } else if (android_method_checker(fnName)) {
            return window.tantan[fnName](`successAlipay${uid}`, `failAlipay${uid}`);
        }
    } else if (oldIOS_method_checker(fnName)) {
        return window[fnName](successAlipay, failAlipay);
    } else if (ios_method_checker(fnName)) {
        window[`successAlipay${uid}`] = successAlipay;
        window[`failAlipay${uid}`] = failAlipay;
        window.webkit.messageHandlers.bindAlipay.postMessage({
            success: `successAlipay${uid}`,
            fail: `failAlipay${uid}`,
        });
    } else {
        return console.info("无法绑定支付宝", 0.5);
    }
}


export async function getABNames() {
    const transStringToArr = (str: string, ios: boolean) => {
        let result: string[] = []
        if (str.length > 2 && !ios) {
            result = str.slice(1, -1).split(',')
        }
        if (str.length > 2 && ios) {
            result = JSON.parse(str)
        }
        return result
    };
    const fnName = 'getABNames';
    if (isAndroid) {
        return Promise.resolve(transStringToArr(window.tantan.dispatch(fnName, JSON.stringify([])), false) as string[])
    } else if (oldIOS_method_checker(fnName)) {
        return transStringToArr(window[fnName](), true) as string[]
    } else if (ios_method_checker(fnName)) {
        return new Promise<string[]>((resolve, reject) => {
            const time = Math.floor(Math.random() * 100)
            window[`getABNamesSuccess${time}`] = (res: string) => { resolve(transStringToArr(res, true)) }
            window[`getABNamesFail${time}`] = (err: any) => { reject(err) }
            window.webkit.messageHandlers.getABNames.postMessage({
                success: `getABNamesSuccess${time}`,
                fail: `getABNamesFail${time}`,
            })
        })
    }
    console.error(`no method matched for ${fnName}`);
    return []
}

/* eslint-enable */
